module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Produkty")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Zapisz")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.products), function(product, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.variety))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.origin))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "0"
      }
    }, [_c('label', {
      staticStyle: {
        "display": "block",
        "cursor": "pointer",
        "padding": "10px",
        "margin-bottom": "0"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.featured),
        expression: "featured"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.disabled(product)
      },
      domProps: {
        "value": product.id,
        "checked": Array.isArray(_vm.featured) ? _vm._i(_vm.featured, product.id) > -1 : (_vm.featured)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.featured,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = product.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.featured = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.featured = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.featured = $$c
          }
        }
      }
    })])])])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('strong', [_vm._v("Informacja")]), _vm._v("\n    Maksymalnie można wyróżnić do 10 produktów\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nazwa")]), _vm._v(" "), _c('th', [_vm._v("Odmiana")]), _vm._v(" "), _c('th', [_vm._v("Pochodzenie")]), _vm._v(" "), _c('th', [_vm._v("Wyróżnienie")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96732f5a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Products.vue
// module id = 463
// module chunks = 1